import { jsx as f, jsxs as H } from "react/jsx-runtime";
import * as a from "react";
import { forwardRef as I } from "react";
import { c as M } from "./index-DLeNytVF.js";
import { u as j } from "./index-DLcqcWxM.js";
import { c as B } from "./index-UFb2E87s.js";
import { u as C } from "./index-DwYXX2sM.js";
import { u as O } from "./index-BZPx6jYI.js";
import { u as U } from "./index-CHDs-SiB.js";
import "react-dom";
import { c as q } from "./index-CM5R_ZZi.js";
import { $ as S } from "./utils-CTvPli9r.js";
function z({
  prop: e,
  defaultProp: r,
  onChange: t = () => {
  }
}) {
  const [o, s] = A({ defaultProp: r, onChange: t }), n = e !== void 0, i = n ? e : o, c = C(t), u = a.useCallback(
    (l) => {
      if (n) {
        const d = typeof l == "function" ? l(e) : l;
        d !== e && c(d);
      } else
        s(l);
    },
    [n, e, s, c]
  );
  return [i, u];
}
function A({
  defaultProp: e,
  onChange: r
}) {
  const t = a.useState(e), [o] = t, s = a.useRef(o), n = C(r);
  return a.useEffect(() => {
    s.current !== o && (n(o), s.current = o);
  }, [o, s, n]), t;
}
var D = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], g = D.reduce((e, r) => {
  const t = q(`Primitive.${r}`), o = a.forwardRef((s, n) => {
    const { asChild: i, ...c } = s, u = i ? t : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(u, { ...c, ref: n });
  });
  return o.displayName = `Primitive.${r}`, { ...e, [r]: o };
}, {}), w = "Switch", [F, ce] = B(w), [L, W] = F(w), y = a.forwardRef(
  (e, r) => {
    const {
      __scopeSwitch: t,
      name: o,
      checked: s,
      defaultChecked: n,
      required: i,
      disabled: c,
      value: u = "on",
      onCheckedChange: l,
      form: m,
      ...d
    } = e, [p, E] = a.useState(null), T = j(r, (b) => E(b)), v = a.useRef(!1), k = p ? m || !!p.closest("form") : !0, [h = !1, _] = z({
      prop: s,
      defaultProp: n,
      onChange: l
    });
    return /* @__PURE__ */ H(L, { scope: t, checked: h, disabled: c, children: [
      /* @__PURE__ */ f(
        g.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": h,
          "aria-required": i,
          "data-state": N(h),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: u,
          ...d,
          ref: T,
          onClick: M(e.onClick, (b) => {
            _(($) => !$), k && (v.current = b.isPropagationStopped(), v.current || b.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ f(
        X,
        {
          control: p,
          bubbles: !v.current,
          name: o,
          value: u,
          checked: h,
          required: i,
          disabled: c,
          form: m,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
y.displayName = w;
var P = "SwitchThumb", R = a.forwardRef(
  (e, r) => {
    const { __scopeSwitch: t, ...o } = e, s = W(P, t);
    return /* @__PURE__ */ f(
      g.span,
      {
        "data-state": N(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...o,
        ref: r
      }
    );
  }
);
R.displayName = P;
var X = (e) => {
  const { control: r, checked: t, bubbles: o = !0, ...s } = e, n = a.useRef(null), i = O(t), c = U(r);
  return a.useEffect(() => {
    const u = n.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== t && d) {
      const p = new Event("click", { bubbles: o });
      d.call(u, t), u.dispatchEvent(p);
    }
  }, [i, t, o]), /* @__PURE__ */ f(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: t,
      ...s,
      tabIndex: -1,
      ref: n,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function N(e) {
  return e ? "checked" : "unchecked";
}
var x = y, G = R;
const J = I(({ className: e, ...r }, t) => /* @__PURE__ */ f(
  x,
  {
    className: S(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      e
    ),
    ...r,
    ref: t,
    children: /* @__PURE__ */ f(
      G,
      {
        className: S(
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
J.displayName = x.displayName;
export {
  J as Switch
};
//# sourceMappingURL=switch.js.map
